/* eslint-disable no-console */

/**
 * FFA Event Dashboard - Flyout Scorecard
 *
 * Creates a right-side flyout panel showing the current page route scorecard.
 */

(function dashboardFlyoutModule(window) {
  window.util = window.util || {};
  window.util.dashboardPages = window.util.dashboardPages || {};

  const PANEL_ID = 'ffa-event-dashboard-panel';
  const TAB_ID = 'ffa-event-dashboard-tab';
  const TABLE_BODY_ID = 'ffa-event-dashboard-table-body';
  const STATUS_ID = 'ffa-event-dashboard-panel-status';

  function getDashboardApi() {
    return window.util && window.util.dashboardPages ? window.util.dashboardPages : null;
  }

  function injectStyles() {
    if (document.getElementById('ffa-event-dashboard-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'ffa-event-dashboard-styles';

    style.textContent = `
      #${PANEL_ID} {
        position: fixed;
        top: 80px;
        right: 0;
        width: 320px;
        max-height: calc(100vh - 120px);
        background: #ffffff;
        border: 1px solid #d0d0d0;
        border-right: none;
        border-radius: 8px 0 0 8px;
        box-shadow: 0 4px 18px rgba(0, 0, 0, 0.18);
        z-index: 2147483647;
        font-family: Arial, sans-serif;
        font-size: 13px;
        color: #222;
        overflow: hidden;
        transition: transform 180ms ease-in-out;
      }

      #${PANEL_ID}.is-collapsed {
        transform: translateX(100%);
      }

      #${TAB_ID} {
        position: fixed;
        top: 120px;
        right: 0;
        z-index: 2147483647;
        padding: 10px 8px;
        background: #111;
        color: #fff;
        border: 1px solid #111;
        border-radius: 6px 0 0 6px;
        font-family: Arial, sans-serif;
        font-size: 12px;
        cursor: pointer;
        writing-mode: vertical-rl;
        text-orientation: mixed;
        display: none;
      }

      #${TAB_ID}.is-visible {
        display: block;
      }

      .ffa-dashboard-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
        padding: 10px 12px;
        background: #111;
        color: #fff;
      }

      .ffa-dashboard-title {
        font-weight: bold;
        font-size: 13px;
        line-height: 1.3;
      }

      .ffa-dashboard-subtitle {
        font-size: 11px;
        color: #cfcfcf;
        margin-top: 2px;
      }

      .ffa-dashboard-actions {
        display: flex;
        gap: 6px;
        align-items: center;
      }

      .ffa-dashboard-actions button {
        padding: 4px 7px;
        border: 1px solid #777;
        border-radius: 4px;
        background: #fff;
        color: #111;
        cursor: pointer;
        font-size: 11px;
      }

      .ffa-dashboard-body {
        padding: 10px;
        overflow: auto;
        max-height: calc(100vh - 190px);
      }

      .ffa-dashboard-table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
      }

      .ffa-dashboard-table th,
      .ffa-dashboard-table td {
        border-bottom: 1px solid #e6e6e6;
        padding: 7px 5px;
        text-align: left;
        vertical-align: top;
      }

      .ffa-dashboard-table th {
        font-size: 11px;
        background: #f5f5f5;
        color: #333;
      }

      .ffa-dashboard-event-name {
        width: 64%;
        word-break: break-word;
      }

      .ffa-dashboard-count {
        width: 18%;
        text-align: center;
        font-weight: bold;
      }

      .ffa-dashboard-pass {
        color: #137333;
      }

      .ffa-dashboard-fail {
        color: #b3261e;
      }

      .ffa-dashboard-empty {
        padding: 10px;
        background: #fff7e6;
        border: 1px solid #f0d28a;
        border-radius: 6px;
        color: #5c4100;
        line-height: 1.4;
      }

      #${STATUS_ID} {
        margin-top: 8px;
        font-size: 11px;
        color: #666;
      }
    `;

    document.head.appendChild(style);
  }

  function findScorecardForCurrentRoute(dashboardState) {
    const currentPath = window.location.pathname;

    if (!Array.isArray(dashboardState)) {
      return null;
    }

    return (
      dashboardState.find((scorecard) => {
        return currentPath.includes(scorecard.route);
      }) || null
    );
  }

  function createPanelShell() {
    if (document.getElementById(PANEL_ID)) {
      return;
    }

    const panel = document.createElement('div');
    panel.id = PANEL_ID;

    panel.innerHTML = `
      <div class="ffa-dashboard-header">
        <div>
          <div class="ffa-dashboard-title">FFA Event Scorecard</div>
          <div class="ffa-dashboard-subtitle" id="ffa-event-dashboard-route-label">Loading route...</div>
        </div>

        <div class="ffa-dashboard-actions">
          <button type="button" id="ffa-event-dashboard-refresh">Refresh</button>
          <button type="button" id="ffa-event-dashboard-collapse">Hide</button>
        </div>
      </div>

      <div class="ffa-dashboard-body">
        <table class="ffa-dashboard-table">
          <thead>
            <tr>
              <th class="ffa-dashboard-event-name">Event</th>
              <th class="ffa-dashboard-count">Pass</th>
              <th class="ffa-dashboard-count">Fail</th>
            </tr>
          </thead>
          <tbody id="${TABLE_BODY_ID}">
            <tr>
              <td colspan="3">Loading...</td>
            </tr>
          </tbody>
        </table>

        <div id="${STATUS_ID}"></div>
      </div>
    `;

    const tab = document.createElement('button');
    tab.id = TAB_ID;
    tab.type = 'button';
    tab.textContent = 'Scorecard';

    document.body.appendChild(panel);
    document.body.appendChild(tab);

    document.getElementById('ffa-event-dashboard-refresh').addEventListener('click', () => {
      renderScorecard();
    });

    document.getElementById('ffa-event-dashboard-collapse').addEventListener('click', () => {
      collapsePanel();
    });

    tab.addEventListener('click', () => {
      expandPanel();
    });
  }

  function collapsePanel() {
    const panel = document.getElementById(PANEL_ID);
    const tab = document.getElementById(TAB_ID);

    if (panel) {
      panel.classList.add('is-collapsed');
    }

    if (tab) {
      tab.classList.add('is-visible');
    }
  }

  function expandPanel() {
    const panel = document.getElementById(PANEL_ID);
    const tab = document.getElementById(TAB_ID);

    if (panel) {
      panel.classList.remove('is-collapsed');
    }

    if (tab) {
      tab.classList.remove('is-visible');
    }
  }

  function renderEmptyState(message) {
    const tableBody = document.getElementById(TABLE_BODY_ID);
    const routeLabel = document.getElementById('ffa-event-dashboard-route-label');
    const status = document.getElementById(STATUS_ID);

    if (routeLabel) {
      routeLabel.textContent = `Current path: ${window.location.pathname}`;
    }

    if (tableBody) {
      tableBody.innerHTML = `
        <tr>
          <td colspan="3">
            <div class="ffa-dashboard-empty">${message}</div>
          </td>
        </tr>
      `;
    }

    if (status) {
      status.textContent = `Last checked: ${new Date().toLocaleTimeString()}`;
    }
  }

  async function renderScorecard() {
    const api = getDashboardApi();

    if (!api || typeof api.getDashboardState !== 'function') {
      renderEmptyState('Dashboard API not available.');
      return;
    }

    const dashboardState = await api.getDashboardState();
    const scorecard = findScorecardForCurrentRoute(dashboardState);

    if (!scorecard) {
      renderEmptyState(`No scorecard found for route: ${window.location.pathname}`);
      return;
    }

    const tableBody = document.getElementById(TABLE_BODY_ID);
    const routeLabel = document.getElementById('ffa-event-dashboard-route-label');
    const status = document.getElementById(STATUS_ID);

    if (routeLabel) {
      routeLabel.textContent = `${scorecard.pageType} | ${scorecard.route}`;
    }

    if (tableBody) {
      tableBody.innerHTML = '';

      scorecard.events.forEach((eventItem) => {
        const row = document.createElement('tr');

        row.innerHTML = `
          <td class="ffa-dashboard-event-name">${eventItem.name}</td>
          <td class="ffa-dashboard-count ffa-dashboard-pass">${eventItem.pass}</td>
          <td class="ffa-dashboard-count ffa-dashboard-fail">${eventItem.fail}</td>
        `;

        tableBody.appendChild(row);
      });
    }

    if (status) {
      status.textContent = `Last refreshed: ${new Date().toLocaleTimeString()}`;
    }
  }

  async function initializeDashboardFlyout(options = {}) {
    const collapsed = options.collapsed === true;

    injectStyles();
    createPanelShell();

    const api = getDashboardApi();

    if (api && typeof api.initializeIndexDB === 'function') {
      await api.initializeIndexDB({ reset: false, log: false });
    }

    await renderScorecard();

    if (collapsed) {
      collapsePanel();
    }

    return {
      success: true,
      collapsed,
    };
  }

  window.util.dashboardPages.renderScorecard = renderScorecard;
  window.util.dashboardPages.initializeDashboardFlyout = initializeDashboardFlyout;
  window.util.dashboardPages.collapseDashboardFlyout = collapsePanel;
  window.util.dashboardPages.expandDashboardFlyout = expandPanel;
})(window);
